import Vue from 'vue'
import { Row, Col, Form, Input, Button, Table, Popconfirm, message, Checkbox, Radio } from 'ant-design-vue'
Vue.use(Row)
Vue.use(Col)
Vue.use(Form)
Vue.use(Input)
Vue.use(Button)
Vue.use(Table)
Vue.use(Popconfirm)
Vue.use(Checkbox)
Vue.use(Radio)
Vue.prototype.$message = message
